<style>
@import "./assets/css/base.css";
@import "./assets/css/common.css";
</style>

<template>
  <div id="app" :class="isdark ? 'dark_app' : ''">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>
<script>
import VConsole from 'vconsole'

export default {
  name: "App",
  data() {
    return {
      isdark: false
    };
  },

  mounted() {
  },
  created() {
    this.isdark = this.$appUtils.appDarkModel() || false;
  }
};
</script>

<style lang="scss">
#app,
body,
html {
  width: 100%;
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
}

.van-field {
  box-shadow: 0px -1px 0px 0px rgba(244, 244, 244, 1);
  border: 1px solid rgba(228, 228, 228, 1);
}

.article_content img {
  max-width: 100%;
  height: auto;
}

/* .van-overlay{
  background:rgba(0,0,0,1) !important;
  opacity:0.35 !important;
}
@-webkit-keyframes van-fade-in{from{opacity:0}to{opacity:0.35}}
@keyframes van-fade-in{from{opacity:0}to{opacity:0.35}}
@-webkit-keyframes van-fade-out{from{opacity:0.35}to{opacity:0}}
@keyframes van-fade-out{from{opacity:0.35}to{opacity:0}} */
.dark_app {
  background: #333333 !important;

  .patient,
  .content2,
  .evaluate_content,
  .area-steps,
  .actived::after,
  .first-step,
  .last-step,
  .img-content .remarks,
  .fixed-button,
  .prescriptions-ul,
  .qrcode_content,
  .sunmit_content,
  .feedback,
  .sunmit_content,
  .feeling_content .feel_p,
  .address_content,
  .express_content .express_head,
  .express_ul .express_li,
  .phone_content,
  .inputphone,
  .inputtest,
  .down-part .download,
  .qrcode_content,
  .phone_content,
  .prescriptions-ul .content,
  .prescription-name,
  .keyboard .content i,
  .prescriptions-ul > li,
  .survey-content,
  .defalut-survey-ul > li,
  .patient-self-report,
  .survey-detail,
  .van-cell-group,
  .van-cell,
  .home-header {
    background-color: #333333 !important;
  }

  .phone_tips,
  .search-result-fixed,
  .area_code,
  .index .content {
    background-color: #272424 !important;
  }

  .edit-content .edit-text,
  .edit-content .edit-area,
  .edit-content .edit-textarea,
  .edit-content .edit-switch,
  .tags-name-content label,
  .popup-window .title,
  .popup-window .tag-text,
  .area-popup-title,
  .area-steps .step-p,
  .hot-citys-name,
  .area-initials-li,
  input,
  textarea,
  .comment_ul .comment_li .clc_contet,
  .comment_ul .comment_li .clc_replies_content,
  .phone_content .phone_title,
  .alert_content,
  .diagnosis-num,
  .case-text,
  .kf-popup-window .title,
  .img-content .remarks > p,
  .search-input,
  .cases-ul .title,
  .cases-ul .symptom,
  .cases-ul .provenace,
  .qcode-content .text,
  .search-input,
  .tab-ul > li,
  .categories-title,
  .categories-ul > li > div,
  .downindex,
  .alert_content,
  .followup,
  .feedback .feedback_title,
  .feedback .feedback_p1 span,
  .content,
  .pharmacy_content .pharmacy_content2,
  .pharmacy_content .pharmacy_content2 .pharmacy_p1,
  .charging_content .charging_p1,
  .order_login,
  .prescriptionlist > div,
  .prescription .content .name,
  .prescription .content input,
  .add .content input,
  .usages-popup-window .usages-ul > li,
  .search-input,
  .home-header .title {
    color: #ffffff !important;
  }

  .tags-ul > li,
  .comment_li_content .clc_nickname,
  .clc_replies_head .clc_replies_nickname,
  .clc_replies_content span,
  .index_expiry,
  .index_available,
  .second_title1 .key,
  .second_title2 .key,
  .case-text .label,
  .prescriptions-ul > li .content,
  .feedback .feedback_p1,
  .feedback .feedback_p3,
  .address_content .address_add,
  .content_details,
  .phone_tips,
  .address_add,
  .content_details,
  .look-qcode,
  .prescription .unit,
  .prescriptions-ul > li .content,
  .questions-ul .question-index,
  .operation-ul .color2 {
    color: #cccccc !important;
  }

  .patient .content2,
  .feedback,
  .evaluate_content,
  .remarks,
  .doctor-info .info,
  .qcode-content,
  .diseases-content,
  .introduction-content,
  .prescriptions-ul > li,
  .personal_card,
  .patient_head_title,
  .feeling_content .feel_p,
  .feeling_content .feel_active,
  .sunmit_content,
  .content,
  .chiose_p,
  .down-part .download,
  .personal,
  .prescription-name,
  .prescriptions-ul > li,
  .survey-content,
  .questions-ul > li,
  .question-name > input,
  .option-question-ul > input,
  .defalut-survey-ul > li,
  .patient-info,
  .patient-self-report,
  .survey-detail,
  .survey-ul > li {
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.4) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue